var _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWavy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1280,
    height: 100,
    viewBox: "0 0 1280 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M410.971 64.9274C309.181 64.9259 275.251 -5.89599 183.156 0.469956C135.899 3.73648 102.37 12.4082 58.7462 36.2813C15.1221 60.1544 -18 64.9274 -18 64.9274V82.4376C-18 82.4376 22.8971 62.4285 50.6677 53.7899C102.834 37.5625 154.881 30.7093 189.619 36.2813C224.356 41.8533 322.915 72.8884 410.971 75.2757C499.027 77.663 562.04 25.9379 662.214 35.4872C762.388 45.0364 795.701 74.3182 883.566 75.2757C980.659 76.3337 1037.87 29.121 1128.35 32.3041C1218.83 35.4872 1298 71.2969 1298 71.2969L1306.07 54.5823C1306.07 54.5823 1219.63 -5.89954 1128.35 0.469956C1037.06 6.83945 982.932 70.4998 878.719 64.9274C774.505 59.3549 756.733 -4.30227 657.367 0.469956C558 5.24218 512.761 64.9288 410.971 64.9274Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M877.103 72.885C978.893 72.8836 1012.82 2.06165 1104.92 8.4276C1152.17 11.6941 1185.7 20.3659 1229.33 44.239C1272.95 68.1121 1306.07 72.885 1306.07 72.885V90.3953C1306.07 90.3953 1265.18 70.3861 1237.41 61.7475C1185.24 45.5201 1133.19 38.667 1098.46 44.239C1063.72 49.811 965.16 80.846 877.103 83.2333C789.047 85.6206 726.034 33.8956 625.86 43.4448C525.686 52.9941 492.374 82.2759 404.508 83.2333C307.415 84.2913 250.208 37.0786 159.728 40.2617C69.2487 43.4448 -9.92151 79.2545 -9.92151 79.2545L-17.9999 62.54C-17.9999 62.54 68.4408 2.0581 159.728 8.4276C251.016 14.7971 305.142 78.4574 409.355 72.885C513.569 67.3126 531.341 3.65537 630.708 8.4276C730.074 13.1998 775.314 72.8864 877.103 72.885Z",
    fill: "url(#paint1_linear)",
    fillOpacity: 0.3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M890.029 81.6174C991.819 81.616 1025.75 10.7941 1117.84 17.16C1165.1 20.4265 1198.63 29.0983 1242.25 52.9714C1285.88 76.8445 1319 81.6174 1319 81.6174V99.1277C1319 99.1277 1278.1 79.1185 1250.33 70.4799C1198.17 54.2525 1146.12 47.3994 1111.38 52.9714C1076.64 58.5434 978.085 89.5784 890.029 91.9658C801.973 94.3531 738.96 42.628 638.786 52.1772C538.612 61.7265 505.299 91.0083 417.434 91.9658C320.341 93.0238 263.134 45.8111 172.654 48.9941C82.1744 52.1772 3.00427 87.9869 3.00427 87.9869L-5.0741 71.2724C-5.0741 71.2724 81.3666 10.7905 172.654 17.16C263.941 23.5295 318.068 87.1898 422.281 81.6174C526.495 76.045 544.267 12.3878 643.633 17.16C743 21.9322 788.239 81.6188 890.029 81.6174Z",
    fill: "url(#paint2_linear)",
    fillOpacity: 0.1
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 644.037,
    y1: 0,
    x2: 644.037,
    y2: 82.4376,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#33D5BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD13C",
    stopOpacity: 0.97
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 644.037,
    y1: 7.95764,
    x2: 644.037,
    y2: 90.3953,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#33D5BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD13C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 656.963,
    y1: 16.6901,
    x2: 656.963,
    y2: 99.1277,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6DC4F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#33D5BA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWavy);
export default __webpack_public_path__ + "static/media/wavy.53d96b22ca109731637d97645eb8a8a3.svg";
export { ForwardRef as ReactComponent };